import CampaignSegmentsEngagementProgression from './campaignSegmentsEngagementProgression'
export default CampaignSegmentsEngagementProgression
